export const steps = [
    {
        id: '1',
        message: '¿Que linea telefonica de sucursal desea saber?',
        trigger: '2'
    },
    {
        id: '2',
        options: [
            { value: 'Chiriqui', label: 'Chiriqui', trigger: '3' },
            { value: 'Bocas del toro', label: 'Bocas del toro', trigger: '4' },
            { value: 'Veraguas', label: 'Veraguas', trigger: '5' },
            { value: 'Cocle', label: 'Cocle', trigger: '6' },
            { value: 'Herrera', label: 'Herrera', trigger: '7' },
            { value: 'Colon', label: 'Colon', trigger: '8' },
            { value: 'Los Santos', label: 'Los Santos', trigger: '9' },
            { value: 'Coronado Mall', label: 'Coronado Mall', trigger: '10' },
            { value: 'Panama', label: 'Panama', trigger: '11' },
        ],
    },
    {
        id: '3', //CHIRIQUI
        message: 'Sucursal David Calle 4ta (cuarta)  Tel. 850-8501/850-8502',
        trigger: '12'
    },
    {
        id: '4', //BOCAS DEL TORO
        message: `Sucursal Changuinola Edificio Global Bank
        Tel. 758-7866/6567-8315`,
        trigger: '12'
    },
    {
        id: '5', //VERAGUAS
        message: `Sucursal Changuinola Edificio Global Bank
        Tel. 758-7866/6567-8315`,
        trigger: '12'
    },
    {
        id: '6', //COCLE
        message: `Sucursal  Penonomé
         Centro comercial Plaza Trilli Local Nº 6
         Tel. 997-9970/9974/9976 `,
        trigger: '12'
    },
    {
        id: '7',  //HERRERA
        message: `Sucursal Chitré
        Calle Belarmino Urriola
        Tel. 996-3830 / 996-0603`,
        trigger: '12'
    },
    {
        id: '8',  //COLON
        message: `Plaza Colón 2000
        Local Nº 23
        Tel. 441-9714/
        441-4838/441-6249`,
        trigger: '12'
    },
    {
        id: '9', //LOS SANTOS
        message: `Sucursal Las Tablas La Ermita,Frente a Calle 1ra Edificio Plaza Fedpa 
                  Tel. 994-7384/994-8439`,
        trigger: '12'
    },
    {
        id: '10', //CORONADO MALL
        message: `Super 99/ Segundo Piso 1 Local Nº 328
                 Tel. 240-4979`,
        trigger: '12'
    },
    {
        id: '11',  //SUCURSALES PANAMA
        options: [
            { value: 'El dorado', label: 'El dorado', trigger: '13' },
            { value: 'La Chorrera', label: 'La Chorrera', trigger: '14' },
            { value: 'Casa Matriz', label: 'Casa Matriz', trigger: '15' },
            { value: 'San Miguelito', label: 'San Miguelito', trigger: '16' },
            { value: 'Los Pueblos 2000', label: 'Los Pueblos 2000', trigger: '17' },
            { value: '24 De Diciembre', label: '24 De Diciembre', trigger: '18' }
        ]
    },
    {
        id: '12', // SEGUIR CONSULTA O SALIR 
        options: [
            { value: 1, label: 'realizar otra consulta', trigger: '2' }
        ],
    },
    {
        id: '13',  //EL DORADO
        message: 'Centro Comercial Alambra 1 Local Nº21 Tel.340-5452',
        trigger: '12'
    },
    {
        id: '14',  //LA CHORRERA
        message: `Plaza Coopeve. Local Nº5
                 Tel.244-4228/4104/7659`,
        trigger: '12'
    },
    {
        id: '15',  //CASA MATRIZ
        message: 'Calle 50 con Calle Colombia #26 Tel.340-5400',
        trigger: '12'
    },
    {
        id: '16', //SAN MIGUELITO
        message: 'La Gran Estacion Tel.340-5475',
        trigger: '12'

    },
    {
        id: '17', //LOS PUEBLOS 2000
        message: 'Local N° 58 Tel.217-7743/217-8036',
        trigger: '12'

    },
    {
        id: '18',  //24 DE DICEMBRE
        message: 'La Doña Tel.340-5460/340-5400',
        trigger: '12'
    }
];